import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { type UseQueryOptions, useQuery } from "react-query";
import { VouchersDistributionsRepository } from "./vouchers-distribution.api";
import type { BasicDTO } from "./vouchers-distribution.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type QueryFnType = typeof vouchersDistributionsRepository.getProducts;
type ApiData = ExtractFnReturnType<QueryFnType>;
type UseGetProductsOptions = {
  config?: UseQueryOptions<ApiData, AxiosError>;
} & BasicDTO;

export const useGetProducts = ({ config, slug, configName }: UseGetProductsOptions) => {
  return useQuery<ApiData, AxiosError>({
    queryKey: ["vouchers-purchase-catalog-products", slug, configName],
    queryFn: () => vouchersDistributionsRepository.getProducts({ slug, configName }),
    ...config,
  });
};
